import React from 'react'
import {
  DatatableNonResponsiveRow,
  DatatableNonResponsiveCell,
} from '../../atoms/DatatableNonResponsive/DatatableNonResponsive'
import ProdottoInfo from '../../molecules/ProdottoInfo/ProdottoInfo'
import { priceNotation } from '../../../utils/safe'

export const DatatableCartCols = {
  prodotto: { label: 'Descrizione' },
  personalizzazione: { label: 'Personalizzazione', width: '171px' },
  prezzoPezzo: { label: 'Prezzo/Pz', width: '100px' },
  quantita: { label: 'Quantità', width: '100px' },
  totale: { label: 'Totale', width: '100px' },
  actions: { label: '', width: '36px' },
}

const DatatableRowOrdine = ({ articolo, quantita, prezzo, totale, even }) => {
  const prodottoInfoData = {
    image: articolo.main_image,
    thumb_image: articolo.thumb_image,
    codice: articolo.codice,
    titolo: articolo.titolo,
    url: articolo.url,
    colore: articolo?.attributi_lista?.filter(a => a.attributo_chiave === 'colore')?.[0]?.nome,
    taglia: articolo?.attributi_lista?.filter(a => a.attributo_chiave === 'taglia')?.[0]?.nome,
  }
  const cols = DatatableCartCols
  return (
    <DatatableNonResponsiveRow even={even} className="datatable-row-cart">
      <DatatableNonResponsiveCell col={cols.prodotto}>
        <ProdottoInfo prodotto={prodottoInfoData} isPrenotato={false} fromPdf={true} />
      </DatatableNonResponsiveCell>
      <DatatableNonResponsiveCell
        col={cols.prezzoPezzo}
        className="datatable-row-cart__bspaced-cell"
      >
        {priceNotation(prezzo, 3)} €
      </DatatableNonResponsiveCell>
      <DatatableNonResponsiveCell col={cols.quantita} className="datatable-row-cart__bspaced-cell">
        <div className="quantity-edit">
          <span className="quantity-edit__value">{quantita}</span>
        </div>
      </DatatableNonResponsiveCell>
      <DatatableNonResponsiveCell col={cols.totale} className="datatable-row-cart__bspaced-cell">
        <b>{priceNotation(totale, 2)} €</b>
      </DatatableNonResponsiveCell>
    </DatatableNonResponsiveRow>
  )
}

export default DatatableRowOrdine
